import React, { useState } from "react";
import { Loginuser } from "../../Helper/LoginHelper";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./LoginComponent.css";

const LoginComponent = () => {
  const navigate = useNavigate();

  const [logo] = useState(
    `${process.env.PUBLIC_URL}/assets/images/logo_latest.png`
  );
  const [loader, setLoader] = useState(false);

  const [inputField, setInputField] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });

  const handleInput = (evt) => {
    const { name, value, type, checked } = evt.target;

    setInputField((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleLoginData = async (evt) => {
    evt.preventDefault();

    const payload = {
      email: inputField.email.trim(),
      password: inputField.password.trim(),
    };

    if (!payload.email || !payload.password) {
      toast.error("Email and Password are required");
      return;
    }

    setLoader(true);

    try {
      const response = await Loginuser(payload);

      // Adjust if API returns wrapped data
      const user = response?.data || response;

      if (user?.id > 0) {
        const {
          id,
          firstName,
          lastName,
          userName,
          roleName,
          permissionView,
          status,
        } = user;

        localStorage.setItem("userId", id);
        localStorage.setItem("name", `${firstName} ${lastName}`);
        localStorage.setItem("userName", userName);
        localStorage.setItem("roleName", roleName);
        localStorage.setItem(
          "permission",
          JSON.stringify(permissionView?.lstmodule || [])
        );

        if (inputField.rememberMe) {
          localStorage.setItem("rememberMe", "true");
        } else {
          localStorage.removeItem("rememberMe");
        }

        toast.success(`Login ${status || "successful"}`);
        window.location.reload();
      } else {
        toast.error(user?.status || "Invalid email or password");
      }
    } catch (error) {
      console.error("Login Error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center flex-column py-5"
      style={{ backgroundColor: "#eff1f9" }}
    >
      <div className="container-fluid">
        <div className="row main-content1 text-center">
          <div className="col-md-4 text-center company__info">
            <span className="company__logo">
              <h2>
                <img src={logo} alt="Company Logo" />
              </h2>
            </span>
          </div>

          <div className="col-md-8 col-xs-12 col-sm-12 login_form">
            <div className="container-fluid">
              <div className="row">
                <h2 className="text-center">Log In</h2>
              </div>

              <form onSubmit={handleLoginData} className="form-group">
                <div className="row">
                  <input
                    type="email"
                    name="email"
                    className="form__input"
                    placeholder="Email"
                    value={inputField.email}
                    onChange={handleInput}
                    required
                    autoComplete="username"
                  />
                </div>

                <div className="row">
                  <input
                    type="password"
                    name="password"
                    className="form__input"
                    placeholder="Password"
                    value={inputField.password}
                    onChange={handleInput}
                    required
                    autoComplete="current-password"
                  />
                </div>

                <div className="row">
                  <input
                    type="checkbox"
                    name="rememberMe"
                    id="rememberMe"
                    checked={inputField.rememberMe}
                    onChange={handleInput}
                  />
                  <label htmlFor="rememberMe"> Remember Me</label>
                </div>

                <div className="row d-flex align-items-center">
                  <button
                    type="submit"
                    className="btn1 btn-primary btn-lg"
                    disabled={loader}
                  >
                    {loader ? "Logging in..." : "Login"}
                  </button>

                  {loader && (
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/loader/loader.gif`}
                      alt="Loading..."
                      className="img-fluid ml-3"
                      style={{ width: "50px", height: "50px" }}
                    />
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid text-center footer">
        <p>
          Coded with &hearts; by{" "}
          <a
            href="https://webmindstechnologies.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Webminds Technologies.
          </a>
        </p>
      </div>
    </div>
  );
};

export default LoginComponent;
